import { ConvertHelper } from "../../helpers/convert-helper"

import { IJsonSerializable } from "../util/interfaces"

import { OpEnumObject } from "./op-enum-object"


export class OpEmergencyCreditInfo implements IJsonSerializable {

    // Properties 

    public usedEC: number
    public emergencyCreditTopupValue: number
    public emergencyCreditAvailableAt: number
    public consumerTypeEcLimit: number
    public ecRepaymentPercentage: number
    public emergencyCreditInfoColorHex: string

    // Properties End


    // Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.usedEC = opObj.UsedEC
            this.emergencyCreditTopupValue = opObj.EmergencyCreditTopupValue
            this.emergencyCreditAvailableAt = opObj.EmergencyCreditAvailableAt
            this.consumerTypeEcLimit = opObj.ConsumerTypeEcLimit
            this.ecRepaymentPercentage = opObj.EcRepaymentPercentage
            this.emergencyCreditInfoColorHex = opObj.EmergencyCreditInfoColorHex
        }
    }

    public toJSON(compressed: boolean = false) {
        return {
            UsedEC: this.usedEC,
            EmergencyCreditTopupValue: this.emergencyCreditTopupValue,
            EmergencyCreditAvailableAt: this.emergencyCreditAvailableAt,
            ConsumerTypeEcLimit: this.consumerTypeEcLimit,
            EcRepaymentPercentage: this.ecRepaymentPercentage,
            EmergencyCreditInfoColorHex: this.emergencyCreditInfoColorHex,
        }
     }

    // IJsonSerializable Implementation End
}